<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            {{ this.grade.name }}
                        </li>
                        <!--<li class="ml-auto" v-if="profile.isStudent">
                            <button v-on:click="modal.redeem = true" class="btn btn-danger btn-sm">
                                Redeem Credit
                            </button>
                        </li>-->
                    </ul>
                </nav>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                            Mata Pelajaran
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body py-0">
                                <div class="row">
                                    <div class="col-12 col-sm-6 border-bottom py-3" v-for="gradeSubject in gradeSubjects">
                                        <router-link v-bind:to="{ name: 'forum/category', params: {id: gradeSubject.id} }" class="font-weight-bold h4 mb-1">{{ gradeSubject.subject.name }}</router-link>
                                        <div class="row text-muted">
                                            <div class="col">
                                                {{ gradeSubject.subtitle }}
                                            </div>
                                        </div>
                                        <div class="row text-muted">
                                            <!--<div class="col-auto">
                                                Jumlah Materi: {{ gradeSubject.totalTeachingMaterials }}
                                            </div>
                                            <div class="col-auto">
                                                Jumlah Thread: {{ gradeSubject.totalThreads }}
                                            </div>
                                            <div class="col-auto">
                                                Solved Thread: {{ gradeSubject.solvedThreads }}
                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="modal.redeem" size="sm" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Redeem Kode Voucher Credit
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="redeem">
                    <div class="row">
                        <div class="col">
                            <input v-model="form.code" class="form-control form-control-sm" required placeholder="Masukan kode voucher" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col mt-4 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-3 mx-2 mb-2">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-3 mx-2 mb-2" type="button" v-on:click="modal.redeem = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "ForumSubject",
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {code: ''},
                grade: {},
                gradeSubjects: [],
                modal: {redeem: false}
            };
        },
        methods: {
            redeem() {
                this.axios.post(process.env.API_URL + '/forum-voucher/redeem', this.form, {meta: {throwError: false}}).then(response => {
                    if (response.data) {
                        if (response.data.status) {
                            for (let i in this.form) {
                                this.form[i] = '';
                            }
                            this.modal.redeem = false;
                            this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
                            this.$toastr('success', response.data.message, 'Success');
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    } else if (response.response) {
                        this.$toastr('warning', response.response.statusText, 'Warning');
                    }
                });
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/grade-subject', {params: {gradeID: this.$route.params.id}})
            ]).then(this.axios.spread(function (responseGrade, responseGradeSubject) {
                if (this.profile.isStudent && this.profile.student.gradeID !== parseInt(this.$route.params.id)) {
                    this.$router.replace({name: 'forum/subject', params: {id: this.profile.student.gradeID}});
                }

                this.grade = responseGrade.data.data;
                this.gradeSubjects = responseGradeSubject.data.data;

                document.title = 'Forum - ' + this.grade.name + ' | ' + process.env.APP_NAME;
            }.bind(this)));

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Subject.vue